export default {"src":"/_next/static/media/extrernal-link-40.152b86a7.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};